module.exports = __webpack_public_path__ + "static/media/interiors-by-sisk.9d6fa561.png";